import { useEffect } from 'react'
import { Text, Image } from '@/ui'
import { PlaidItem } from '@/reducers/finances/plaidItemReducer'
import { useAnalyticsView } from '@/features/amplitude'
import { TypographyStyles } from '@/styles'

export const LBAInterestConfirmationPage = ({
  filteredPlaidItems,
}: {
  filteredPlaidItems: PlaidItem[]
}) => {
  const pageView = useAnalyticsView()

  useEffect(() => {
    pageView('lba interest confirmation')
  }, [pageView])

  return (
    <div className="flex flex-col lg:flex-row gap-6 mt-4">
      <div className="w-full lg:w-1/3">
        <Image
          src="https://heard-images.s3.amazonaws.com/assets/green-check.png"
          alt="Green checkmark"
          className="bg-moss-25 p-20"
        />
      </div>

      <div className="w-full lg:w-2/3 space-y-4">
        <Text variant={TypographyStyles.H2}>Thanks for letting us know</Text>

        {filteredPlaidItems.length > 0 ? (
          <>
            <Text>
              We&apos;ll reach out via Messages with instructions for providing
              us limited bank access to accounts that support it. You won&apos;t
              need to upload bank statements for those accounts.
            </Text>
            <Text className="mt-4">
              You&apos;ll still need to upload bank statements for accounts at
              these banks, since they don&apos;t support bank access:
            </Text>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              {filteredPlaidItems.map((item) => (
                <li key={item.id}>
                  <Text>{item.institutionName}</Text>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <Text>
            We&apos;ll reach out via Messages with instructions for providing us
            limited bank access to your accounts. By allowing this access, you
            won&apos;t need to upload bank statements every month.
          </Text>
        )}
      </div>
    </div>
  )
}
